import { Component, OnInit, ViewChild } from '@angular/core';
import { ReportService } from '../../services/report.service';
import { UserService } from '../../services/user.service';
import { BaseReportComponent } from '../reports/base-report.component';

@Component({
  selector: 'customer-order-cancellation-report',
  templateUrl: './customer-order-cancellation-report.component.html',
})
export class CustomerOrderCancellationReportComponent extends BaseReportComponent<any, any, any> {
  public organisationTypeId: number = 0;
  public isBusyOrganisationType: boolean = false;

  public customers: any[] = [];

  constructor(reportService: ReportService<any, any>, private userService: UserService) {
    super(reportService, true);
    reportService.url = '/api/report/ordercancellation';
  }

  ngOnInit() {
    super.ngOnInit();
    this.initializeCurrentUserOrgType();
  }

  public initializeCurrentUserOrgType() {
    this.isBusyOrganisationType = true;
    this.userService
      .getCurrentUserOrg()
      .then((organisation) => {
        this.isBusyOrganisationType = false;
        if (organisation) {
          this.organisationTypeId = organisation.organisationTypeId;
        }
      })
      .catch((x) => {
        this.isBusyOrganisationType = false;
      });
  }

  public callbackLoadFilterParam() {
    this.customers = [];

    if (this.filterParam) {
      if (this.filterParam.customers) {
        this.customers.push({ label: 'Please Select', value: null });
        this.filterParam.customers.forEach((x) => {
          this.customers.push({ label: x.label, value: x.value });
        });
      }
    }
  }

  initDefaultFilter() {
    super.initDefaultFilter();
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '',
      sortOrder: 1,
      filters: {
        createDateFrom: {},
        createDateTo: {},
        cancelDateFrom: {},
        cancelDateTo: {},
        customer: {},
        orderRef: {},
      },
    };
  }
}
